<template>
  <div class="nft-type-filter-comp">
    <div class="tab-list">
      <div
          v-for="(type, index) in cltnTypeList"
          :key="index"
          class="tab-item"
          @click="changeCtgy(type.value)"
      >
        <mv-tab
            :content="type"
            :selected="filters.ctgy === type.value"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import MvTab from '@/components/common/tab/MvTab.vue';
import {useCltnListFilter} from '@/script/homeScript';

export default defineComponent({
  name: 'NftTypeFilterComp',
  components: {
    MvTab,
  },
  setup() {
    const {
      filters,
      changeCtgy,
    } = useCltnListFilter()

    const cltnTypeList = [
      {
        label: 'nftType.all',
        value: ''
      },
      {
        label: 'nftType.MEMBERSHIP',
        value: 'MEMBERSHIP',
      },
      {
        label: 'nftType.TICKET',
        value: 'TICKET',
      },
    ]

    return {
      cltnTypeList,
      filters,
      changeCtgy,
    }
  }
})
</script>
